import React, {useState} from 'react';
import {Wrapper} from "./index.styles";
import ViewPersonalInfo from "./components/view";
import EditPersonalInfo from "./components/edit";
import {IEKYCDetails, TUsersDetail} from "../../../../../../types/entities/users";

interface PersonalInfoProps {
  data: any;
  setNextPage: () => void;
  handleSkip: () => void;
  setUpdatedData: (data: IEKYCDetails) => void;
  updatedData: any;
  userData?: TUsersDetail
  disableEdit: boolean;
}

const PersonalInfo = ({
  setNextPage,
  handleSkip,
  data,
  disableEdit,
  updatedData,
  userData,
  setUpdatedData,
}: PersonalInfoProps) => {
  const [mode, setMode] = useState('view');

  return (
    <Wrapper>
      {mode === 'view' && (
        <ViewPersonalInfo
          setMode={setMode}
          data={data}
          updatedData={updatedData}
          userData={userData}
          setNextPage={setNextPage}
          handleSkip={handleSkip}
          disableEdit={disableEdit}
        />
      )}
      {mode === 'edit' && (
        <EditPersonalInfo
          setMode={setMode}
          data={updatedData}
          setUpdatedData={setUpdatedData}
        />
      )}
    </Wrapper>
  );
};

export default PersonalInfo;
